import * as React from 'react';
import {Breadcrumbs, Input, Link} from "@mui/joy";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import SearchIcon from '@mui/icons-material/Search';
import VoicemailTable from "../tables/VoicemailTable";
import { useLocation } from 'react-router-dom';

// Local storage key for category filter (shared across messages/voicemails)
const CATEGORY_FILTER_KEY = 'messagesCategoryFilter';

export default function Voicemails() {
    const location = useLocation();
    const [search, setSearch] = React.useState('');
    const [idFilter, setIdFilter] = React.useState<string | null>(null);
    
    // Category filter with localStorage persistence
    const [category, setCategory] = React.useState(() => {
        return localStorage.getItem(CATEGORY_FILTER_KEY) || 'All';
    });
    
    // Update localStorage when category changes
    const handleCategoryChange = React.useCallback((newCategory: string) => {
        setCategory(newCategory);
        localStorage.setItem(CATEGORY_FILTER_KEY, newCategory);
    }, []);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('id');
        if (id) {
            setIdFilter(id);
        }
    }, [location]);

    return (
        <>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <Breadcrumbs
                    size="sm"
                    aria-label="breadcrumbs"
                    separator={<ChevronRightRoundedIcon/>}
                    sx={{pl: 0}}
                >
                    <Link
                        underline="none"
                        color="neutral"
                        href="/dashboard"
                        aria-label="Home"
                    >
                        <HomeRoundedIcon/>
                    </Link>
                    <Link
                        underline="hover"
                        color="neutral"
                        href="/dashboard"
                        fontSize={12}
                        fontWeight={500}
                    >
                        Dashboard
                    </Link>
                    <Typography color="primary" fontWeight={500} fontSize={12}>
                        Voicemails
                    </Typography>
                </Breadcrumbs>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    mb: 1,
                    gap: 1,
                    flexDirection: {xs: 'column', sm: 'row'},
                    alignItems: {xs: 'start', sm: 'center'},
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                }}
            >
                <Typography level="h2" component="h1">
                    Voicemails
                </Typography>
                <Box sx={{ 
                    display: 'flex', 
                    gap: 1, 
                    alignItems: { xs: 'stretch', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    width: { xs: '100%', sm: 'auto' },
                }}>
                    <Input
                        size="sm"
                        placeholder="Search by name or phone..."
                        startDecorator={<SearchIcon />}
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setIdFilter(null); // Clear ID filter when searching manually
                        }}
                        sx={{ width: { xs: '100%', sm: '300px' } }}
                    />
                    <Select value={category} onChange={(_, val) => handleCategoryChange(val || 'All')} size="sm" sx={{ width: { xs: '100%', sm: 160 } }}>
                        <Option value="All">All Categories</Option>
                        <Option value="Sales">Sales</Option>
                        <Option value="Existing Booking">Existing Booking</Option>
                    </Select>
                </Box>
            </Box>

            <VoicemailTable search={search} idFilter={idFilter} category={category} />
        </>
    )
}

